module.exports = __webpack_public_path__ + "img/collection-weddingRingsSignature.e0f1aac.jpg";